import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Landing page for "Open Vetobase dashboard" in the Shopify admin app.
// Redeems a single-use code for a normal session, then opens the workspace.
const StoreAppSso = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // redeem once (StrictMode double-invokes effects)
    ran.current = true;
    const code = params.get('code');
    if (!code) { setError('This sign-in link is incomplete.'); return; }
    const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    axios.post(`${API_URL}/api/store-app/sso/redeem`, { code })
      .then(({ data }) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('workspaceName', data.workspaceName);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('userRole', data.role);
        navigate(`/workspace/${data.workspaceUuid}/dashboard`, { replace: true });
      })
      .catch(err => setError(err.response?.data?.message || 'Sign-in failed. Open Vetobase again from your Shopify admin.'));
  }, [params, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--paper, #F9F4EE)', padding: 16 }}>
      <div style={{ background: '#fff', border: '1.5px solid #111', borderRadius: 14, boxShadow: '4px 4px 0 #111', padding: '24px 28px', maxWidth: 420, textAlign: 'center' }}>
        <img src="/vetobase-icon.png" alt="Vetobase" style={{ width: 44, height: 44, borderRadius: 12, marginBottom: 10 }} />
        <h1 style={{ fontSize: 18, margin: '0 0 6px' }}>{error ? 'Could not sign you in' : 'Signing you in…'}</h1>
        <p style={{ margin: 0, color: '#5b5b5b', fontSize: 14 }}>{error || 'Opening your Vetobase workspace.'}</p>
      </div>
    </div>
  );
};

export default StoreAppSso;
